// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-section {
    height: 80%;
    /* margin-top: 24px; */
  }
  
  .chat-section .chat-modal {
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  .chat-item {
    display: flex;
    flex-direction: column;
  }
  
  .chat-header {
    display: flex;
    align-items: center;
    gap: 12px;
    text-transform: capitalize;
  
  }
  
  .chat-image {
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }
  
  .chat-name {
    color: white;
    font-size: 16px;
    font-weight: 500;
    font-family: "Poppins";
    line-height: 22px;
    letter-spacing: 0px;
    margin:0
  }
  
  .chat-message {
    color: white;
    font-size: 14px;
    font-weight: 500;
    font-family: "Karla";
    letter-spacing: 0px;
    /* margin-left: 55px; */
  }
  
  .chat-time {
    color: #8b8b8b;
    font-size: 12px;
    font-weight: 500;
    font-family: "Karla";
    letter-spacing: 0px;
    margin-left: 55px;
    margin-top: 11px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ui/commentSection/CommentSection.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB;MACE,aAAa;IACf;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0BAA0B;;EAE5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB;EACF;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB","sourcesContent":[".chat-section {\n    height: 80%;\n    /* margin-top: 24px; */\n  }\n  \n  .chat-section .chat-modal {\n    height: 100%;\n    overflow-y: auto;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  \n  .chat-item {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .chat-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    text-transform: capitalize;\n  \n  }\n  \n  .chat-image {\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n  }\n  \n  .chat-name {\n    color: white;\n    font-size: 16px;\n    font-weight: 500;\n    font-family: \"Poppins\";\n    line-height: 22px;\n    letter-spacing: 0px;\n    margin:0\n  }\n  \n  .chat-message {\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: \"Karla\";\n    letter-spacing: 0px;\n    /* margin-left: 55px; */\n  }\n  \n  .chat-time {\n    color: #8b8b8b;\n    font-size: 12px;\n    font-weight: 500;\n    font-family: \"Karla\";\n    letter-spacing: 0px;\n    margin-left: 55px;\n    margin-top: 11px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
